export const googleAuthUrlWithEmail = (
  authUrl: string,
  email: string | null,
) => {
  if (!email) return authUrl;
  const url = new URL(authUrl);
  const domain = email!.split('@')[1];
  url.searchParams.set('login_hint', email!);
  url.searchParams.set('hd', domain);
  return url.toString();
};
